export enum DocTypeSource {
  Branch = "branch",
  Company = "company",
  Employee = "employee",
  Vehicle = "vehicle",
}
